export default __webpack_public_path__ + "static/stephanie-827da4fe5dbec6e1a38f9a81bb671140.png";